import { render, staticRenderFns } from "./CampoData.vue?vue&type=template&id=4c8496fa"
import script from "./CampoData.vue?vue&type=script&lang=js"
export * from "./CampoData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports